module.exports = __webpack_public_path__ + "img/Mysql.5903a341.svg";